export default __webpack_public_path__ + "static/ueber-uns-6e4ec528205462a691d9fefb049a8cfc.png";